angular.module( 'acme.view.application.pos.create', [
  'ui.router',
  'ui.bootstrap',
  'acme.common.service.api',
  'acme.common.directive.pos',
  'acme.common.directive.spectrum',
  'acme.view.application.pos.create.controllers',
  'acme.view.application.pos.create.description',
  'acme.view.application.pos.create.images',
  'acme.view.application.pos.create.navigation',
  'acme.view.application.pos.create.pages',
  'acme.view.application.pos.create.settings',
  'acme.view.application.pos.create.modals.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var posCreate = {
        name: 'application.pos.create',
        url: '/create',
        abstract: true,
        views: {
          "subview-main@application": {
            controller: 'PosCreateController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/pos/create/create.tpl.html'
          }
        },
        data: {
          pageTitle: 'Point of Sale Configurator',
          pageClass: 'application application-pos-create',
          /** Secure With Permissions **/
          permissions: ['POS_CONFIG_CREATE']
        },
        resolve: {
          spectrum: ['$q', function($q) {
            var q = $q.defer();

            // Usage
            $.cachedScript( "/assets/spectrum.min.js" ).done(function( script, textStatus ) {
              q.resolve('done');
            }, function() {
              q.resolve('fail');
            });

            return q.promise;
          }],
          spectrumCss: ['$q', function($q) {
            var q = $q.defer();

            // Usage
            $.loadCss( "/assets/spectrum.min.css", 'spectrum', function() {
              q.resolve('done');
            }, function() {
              q.resolve('fail');
            });

            return q.promise;
          }]
        }
      },
      posEdit = {
        name: 'application.pos.edit',
        url: '/:configId/edit',
        abstract: true,
        views: {
          "subview-main@application": {
            controller: 'PosCreateController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/pos/create/create.tpl.html'
          }
        },
        data: {
          pageTitle: 'Point of Sale Configurator',
          pageClass: 'application application-pos-create',
          /** Secure With Permissions **/
          permissions: ['POS_CONFIG_UPDATE']
        },
        resolve: {
          spectrum: ['$q', function($q) {
            var q = $q.defer();

            // Usage
            $.cachedScript( "/assets/spectrum.min.js" ).done(function( script, textStatus ) {
              q.resolve('done');
            }, function() {
              q.resolve('fail');
            });

            return q.promise;
          }],
          spectrumCss: ['$q', function($q) {
            var q = $q.defer();

            // Usage
            $.loadCss( "/assets/spectrum.min.css", 'spectrum', function() {
              q.resolve('done');
            }, function() {
              q.resolve('fail');
            });

            return q.promise;
          }]
        }
      };

    $stateProvider
      .state(posCreate)
      .state(posEdit);
});